/**
 * Popis slovníku metadat dokumentů uložených v systému DMS
 * @includeToDoc
 */
export interface IDocumentMetadata {
    /** Původní hash dat u šifrovaných dokumentů */
    originalHash: string;
    /** Skutečný hash dat uloženého dokumentu */
    hash: string;
    /** Kód algoritmu použitého pro vytvořené hashe */
    hashAlgorithm: string;

    [attribute: string]: string;
}

// ReSharper disable InconsistentNaming

/** Obsahuje informace o jedné konkrétní verzi dokumentu
 * @includeToDoc
 */
export interface IDocumentVersionInfo {
    /** ID archivní verze dokumentu (alias k ArchiveVersionDocID) */
    ID: string;
    /** Jméno dokumentu */
    Name: string;
    /** ID verze dokumentu */
    VersionDocID: string;
    /** Název archivní verze dokumentu */
    ArchiveVersionName: string;
    /** ID archivní verze dokumentu */
    ArchiveVersionDocID: string;
    /** Čas vytvoření dokumentu */
    CreateTime: Date;
    /** Autor nahrání dokumentu */
    Author: string;
    /** Číslo verze */
    Number: number;
}

// ReSharper restore InconsistentNaming
